// frontend/src/components/mcbim/ColorFilterBar.tsx
import React from "react";
import { Button, Group, ScrollArea, Tooltip } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectGetColorFilters } from "../Room/roomSelectors";
import { setActiveColorPanelItemInRedux } from "./designSlice";
import { COLOR_FILTERS_IDS } from "./LeftSidebar/ColorPanel/colorPanelUtils";
import { ModuleToolBarShell } from "./ModuleBars/ModuleToolBarShell";

export const ColorFilterBar: React.FC = () => {
  const dispatch = useAppDispatch();
  const colorFilters = useAppSelector(selectGetColorFilters);
  const activeColorPanelItem = useAppSelector((state) => state.design.activeColorPanelItem);

  const setActive = (id: string | undefined) => {
    dispatch(setActiveColorPanelItemInRedux(id as unknown as COLOR_FILTERS_IDS));
  };

  return (
    <ModuleToolBarShell>
      <ScrollArea type="auto" scrollbarSize={6} offsetScrollbars>
        <Group gap={6} wrap="nowrap" p={4}>
          {/* "Ingen" / reset */}
          <Tooltip label="Ingen fargefilter" withArrow>
            <Button
              size="xs"
              radius="xl"
              variant={!activeColorPanelItem ? "filled" : "outline"}
              color={!activeColorPanelItem ? "blue" : undefined}
              onClick={() => setActive(undefined)}
            >
              Ingen
            </Button>
          </Tooltip>

          {colorFilters.map((filter) => {
            const isActive = filter.id === activeColorPanelItem;

            return (
              <Tooltip key={filter.id} label={filter.title} withArrow>
                <Button
                  size="xs"
                  radius="xl"
                  variant={isActive ? "filled" : "outline"}
                  color={isActive ? "blue" : undefined}
                  onClick={() => setActive(filter.id)}
                >
                  {filter.title}
                </Button>
              </Tooltip>
            );
          })}
        </Group>
      </ScrollArea>
    </ModuleToolBarShell>
  );
};
